import React, { PropTypes } from 'react';
import { Card } from 'semantic-ui-react';
import { Link } from 'react-router';

import LinkedinLogin from '../linkedinLogin/LinkedinLogin';


const propTypes = {
  title: PropTypes.string.isRequired,
  loginText: PropTypes.string.isRequired,
  newText: PropTypes.string.isRequired,
  linkedinLink: PropTypes.string.isRequired,
  formLink: PropTypes.string.isRequired,
  newLink: PropTypes.string.isRequired,
};

const { Content, Header } = Card;

const PreLoginCard = (props) => {
  const { title, loginText, newText, linkedinLink, formLink, newLink } = props;

  return (
    <Card centered raised>
      <Content>
        <Header>{title}</Header>
      </Content>
      <Content>
        <LinkedinLogin to={linkedinLink} {...props} />
        <Link to={formLink}>{loginText}</Link>
      </Content>
      <Content extra>
        <Link to={newLink}>{newText}</Link>
      </Content>
    </Card>
  );
};

PreLoginCard.propTypes = propTypes;
export default PreLoginCard;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/preLoginCard/PreLoginCard.js
 **/